<template>
  <div class="animated fadeIn">
    <form  @submit.stop.prevent="post()">
      <div class="row">
        <div class="col-sm-12">

          <b-card>
            <div slot="header">
              <i class='fa fa-align-justify'></i><strong> Dados do Cadastro</strong>
            </div>
            
            <div class="row">
              <!--/.col-->
              <div class="col-sm-2">
                <b-form-fieldset label="Código/ID">
                  <b-form-input type="text" id="codigo" :state="idValidador" :disabled="desabilitado" placeholder="Código" v-model="registro.ID"> </b-form-input>
                </b-form-fieldset>
              </div>
              <!--/.col-->
                <div class="col-sm-4">
                  <b-form-fieldset label="Situação">
                    <b-form-select :plain="true"  v-model="registro.STATUS" :options="options">
                    </b-form-select>
                  </b-form-fieldset>
                </div>
            </div>
            <div class="row">
              <!--/.col-->
              <div class="col-sm-8">
                <b-form-fieldset label="Descrição">
                  <b-form-input type="text" id="descricao" :state="descricaoValidador"  placeholder="Descricao" v-model="registro.DESCRICAO"> </b-form-input>
                </b-form-fieldset>
              </div>
            </div>
            
            <div class="row mt-3">
              <div class="col-sm-8">
                <b-form-fieldset label="Tela Inicial Padrão (Opcional)">
                  <MenuDropdown 
                    v-model="registro.TELA_INICIAL_PADRAO" 
                    :disabled="desabilitado"
                    placeholder="Usar tela padrão do sistema"
                  />
                  <small class="form-text text-muted">
                    <i class="fa fa-info-circle"></i> 
                    Define a tela inicial para todos os usuários deste grupo. Pode ser sobrescrita individualmente por usuário.
                  </small>
                </b-form-fieldset>
              </div>
            </div>
          </b-card>


        </div>
      </div>
      
      
      <!--/.row-->
      <b-card>
        <div class="row">
          <div class="col-sm-12">
            <b-button  variant="outline-primary" type="button" @click="$router.go(-1)" ><i class="fa fa-arrow-left"></i> Voltar</b-button >
            <vue-button-spinner  type="submit"  
                                    :isLoading="isLoading" 
                                    :disabled="isLoading"
                                    :status="status"
                                    @click="post()">
                                    
                  <i class="fa fa-save"></i> Gravar
                </vue-button-spinner>              
          </div>
        </div>
      </b-card>
    </form>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import MenuDropdown from '@/views/componentes/dropdown/MenuDropdown.vue'

export default {
  data () {
    return { 
      submeteu: false,
      desabilitado: true,
      registro: {},
      isLoading: false,
      status: '',
      options: [
        { value: null, text: 'Informe a Situação' },
        { value: '0', text: 'Inativo' },
        { value: '1', text: 'Ativo' }
      ]
    }
  },
  components: {
    VueButtonSpinner,
    MenuDropdown
  },
  methods: {
    post () {
      this.isLoading = true
      this.submeteu = true
      if (!this.avisos()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        this.isLoading = false
      } else if ((this.$route.params.id === undefined )) {
          this.$http.post(`/api/protected/grupo/acesso/post`, this.registro)
          .then(response => {
            this.isLoading = false
            
            this.toastCount++
            this.$root.$bvToast.toast(`Registro INSERIDO com Sucesso!!!`, {
              title: 'Aviso',
              autoHideDelay: 3000,
              variant: 'success',
              appendToast: true
            })
            this.$store.dispatch('grupoAcesso/GERAR_LISTA')
            .then(() => {
              this.$root.$bvToast.toast(`Lista Atualizada com Sucesso!!!`, {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'success',
                appendToast: true
              })
            })
            .catch(() =>{
              this.$root.$bvToast.toast(`Falha ao atualizar a listagem!!!`, {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'warning',
                appendToast: true
              })
            })
            this.$router.go(-1)
          })
          .catch(erro => {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha ao executar a operação!!`, {
              title: 'Erro',
              autoHideDelay: 15000,
              variant: 'danger',
              appendToast: true
            })
            this.isLoading = false
          })

      } else  {
        this.$http.post(`/api/protected/grupo/acesso/edit`, this.registro)
          .then(response => {
            this.isLoading = false
            this.$root.$bvToast.toast(`Registro ATUALIZADO com Sucesso!!!`, {
              title: 'Aviso',
              autoHideDelay: 3000,
              variant: 'success',
              appendToast: true
            })
            this.$store.dispatch('grupoAcesso/GERAR_LISTA')
            .then(() => {
              this.$root.$bvToast.toast(`Lista Atualizada com Sucesso!!!`, {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'success',
                appendToast: true
              })
            })
            .catch((msg) =>{
              this.$root.$bvToast.toast(`Falha ao atualizar a listagem!!! \n` + msg , {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'warning',
                appendToast: true
              })
            })
            this.$router.go(-1)
          })
          .catch(erro => {
            this.$root.$bvToast.toast(`Falha ao executar a operação!!`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
            this.isLoading = false
          })
      }
    },
    limparRegistro () {
      let registroVazio =
        {
          ID: null,
          DESCRICAO: null,
          STATUS: '1',
          TELA_INICIAL_PADRAO: null
        }
      this.registro = registroVazio
    },
    iniciarFormNovo () {
      this.registro.STATUS = '1'
      this.desabilitado = false
    },
    iniciarFormEditar ( id ) {
      this.desabilitado = true
      let uri = `/api/protected/grupo/acesso/getById/${id}`
      
      this.$http.get(uri)
        .then((response) => {
          
          this.registro = response.data[0]
          if (this.registro.ID === '') {
            this.$bvToast.toast(`Falha ao executar a operação!!`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
            this.$router.replace('/seguranca/grupoAcesso/index') 
          }

        })
       
        , (error) => {
          //this.$router.replace('/seguranca/grupoAcesso/index')
          this.$bvToast.toast(`Falha ao localizar o cadastro!!`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
          
        }
    },
    prepararForm () {
    },
    avisos() {
      return this.descricaoValidador && this.idValidador
    },
    onSelect(items) {
      if (items[0].MARCA == '0') {
         items[0].MARCA = '1'
      } else {
        items[0].MARCA = '0'
      }
      this.tabela.selecionados = items
    }
  },
  created () {
    
    let id = this.$route.params.id
    this.prepararForm()
    if ( id ) {
      this.iniciarFormEditar( id )
    } else {
      this.iniciarFormNovo()
    }
  },
  computed:{
    descricaoValidador(){
      return ((this.registro.DESCRICAO ) && (this.registro.DESCRICAO.length > 2)) ? true : false
    },
    idValidador(){
      return ((this.registro.ID ) && (this.registro.ID > 0)) ? true : false
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/views/seguranca/grupoacesso/GrupoAcessoCadastro.vue